import { render, staticRenderFns } from "./RoleResponsibilitiesComponent.vue?vue&type=template&id=2d9660b4"
import script from "./RoleResponsibilitiesComponent.vue?vue&type=script&lang=js"
export * from "./RoleResponsibilitiesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports